<template>
  <span
    v-if="isCorrectAnswerTogglerVisible"
    class="correct_answer_toggle hover-item "
    @click="toggleCorrectAnswer"
    v-tooltip="isShowingCorrectAnswer ? $i18nPresenter.t('Hide correct answer') : $i18nPresenter.t('Show correct answer')"
  >
    <aha-icon
      v-if="!isShowingCorrectAnswer"

      name="hide_correct_answer"
    ></aha-icon>
    <aha-icon
      v-else

      name="show_correct_answer"
    ></aha-icon>

  </span>
</template>

<script>
export default {
  name: 'ResultAndAnswerToggler',
  props: {
    isCorrectAnswerTogglerVisible: {
      type: Boolean,
      default: false,
    },
    isShowingCorrectAnswer: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    toggleCorrectAnswer() {
      this.$emit('toggleCorrectAnswer', !this.isShowingCorrectAnswer)
    },
  },
}
</script>

<style lang="scss" scoped>

.correct_answer_toggle {
  cursor: pointer;
  display: inline-block;
  margin-left: 20px;;

}

</style>
